import { __extends } from "tslib";
import { PointShadowMapper } from '../mappers/PointShadowMapper';
import { LightBase } from './LightBase';
var PointLight = /** @class */ (function (_super) {
    __extends(PointLight, _super);
    /**
     *
     */
    function PointLight(position, transform) {
        if (position === void 0) { position = null; }
        if (transform === void 0) { transform = null; }
        var _this = _super.call(this, transform) || this;
        _this._radius = 90000;
        _this._fallOff = 100000;
        if (position) {
            _this._transform.matrix3D._rawData[12] = position.x;
            _this._transform.matrix3D._rawData[13] = position.y;
            _this._transform.matrix3D._rawData[14] = position.z;
            _this._transform.invalidatePosition();
        }
        _this._fallOffFactor = 1 / (_this._fallOff * _this._fallOff - _this._radius * _this._radius);
        return _this;
    }
    Object.defineProperty(PointLight.prototype, "assetType", {
        get: function () {
            return PointLight.assetType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PointLight.prototype, "radius", {
        /**
         *
         */
        get: function () {
            return this._radius;
        },
        set: function (value) {
            this._radius = value;
            if (this._radius < 0) {
                this._radius = 0;
            }
            else if (this._radius > this._fallOff) {
                this._fallOff = this._radius;
                //this._pInvalidateBounds();
            }
            this._fallOffFactor = 1 / (this._fallOff * this._fallOff - this._radius * this._radius);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PointLight.prototype, "fallOff", {
        /**
         *
         */
        get: function () {
            return this._fallOff;
        },
        set: function (value) {
            this._fallOff = value;
            if (this._fallOff < 0)
                this._fallOff = 0;
            if (this._fallOff < this._radius)
                this._radius = this._fallOff;
            this._fallOffFactor = 1 / (this._fallOff * this._fallOff - this._radius * this._radius);
            //this._pInvalidateBounds();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PointLight.prototype, "fallOffFactor", {
        get: function () {
            return this._fallOffFactor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PointLight.prototype, "x", {
        /**
         * Indicates the <i>x</i> coordinate of the DisplayObject instance relative
         * to the local coordinates of the parent DisplayObjectContainer. If the
         * object is inside a DisplayObjectContainer that has transformations, it is
         * in the local coordinate system of the enclosing DisplayObjectContainer.
         * Thus, for a DisplayObjectContainer rotated 90° counterclockwise, the
         * DisplayObjectContainer's children inherit a coordinate system that is
         * rotated 90° counterclockwise. The object's coordinates refer to the
         * registration point position.
         */
        get: function () {
            return this._transform.position.x;
        },
        set: function (val) {
            if (this._transform.position.x == val)
                return;
            this._transform.matrix3D._rawData[12] = val;
            this._transform.invalidatePosition();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PointLight.prototype, "y", {
        /**
         * Indicates the <i>y</i> coordinate of the DisplayObject instance relative
         * to the local coordinates of the parent DisplayObjectContainer. If the
         * object is inside a DisplayObjectContainer that has transformations, it is
         * in the local coordinate system of the enclosing DisplayObjectContainer.
         * Thus, for a DisplayObjectContainer rotated 90° counterclockwise, the
         * DisplayObjectContainer's children inherit a coordinate system that is
         * rotated 90° counterclockwise. The object's coordinates refer to the
         * registration point position.
         */
        get: function () {
            return this._transform.position.y;
        },
        set: function (val) {
            if (this._transform.position.y == val)
                return;
            this._transform.matrix3D._rawData[13] = val;
            this._transform.invalidatePosition();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PointLight.prototype, "z", {
        /**
         * Indicates the z coordinate position along the z-axis of the DisplayObject
         * instance relative to the 3D parent container. The z property is used for
         * 3D coordinates, not screen or pixel coordinates.
         *
         * <p>When you set a <code>z</code> property for a display object to
         * something other than the default value of <code>0</code>, a corresponding
         * Matrix3D object is automatically created. for adjusting a display object's
         * position and orientation in three dimensions. When working with the
         * z-axis, the existing behavior of x and y properties changes from screen or
         * pixel coordinates to positions relative to the 3D parent container.</p>
         *
         * <p>For example, a child of the <code>_root</code> at position x = 100, y =
         * 100, z = 200 is not drawn at pixel location(100,100). The child is drawn
         * wherever the 3D projection calculation puts it. The calculation is:</p>
         *
         * <p><code>(x~~cameraFocalLength/cameraRelativeZPosition,
         * y~~cameraFocalLength/cameraRelativeZPosition)</code></p>
         */
        get: function () {
            return this._transform.position.z;
        },
        set: function (val) {
            if (this._transform.position.z == val)
                return;
            this._transform.matrix3D._rawData[14] = val;
            this._transform.invalidatePosition();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PointLight.prototype, "scenePosition", {
        get: function () {
            return this._transform.matrix3D.position;
        },
        enumerable: false,
        configurable: true
    });
    PointLight.prototype._createShadowMapper = function () {
        return new PointShadowMapper();
    };
    PointLight.assetType = '[light PointLight]';
    return PointLight;
}(LightBase));
export { PointLight };
